import 'shared/config/i18n/i18n';

import ReactDOM from 'react-dom/client';
import { BrowserRouter as Router } from 'react-router-dom';

import App from 'app/App';
import { ErrorBoundary } from 'app/providers/ErrorBoundary';
import MUThemeProvider from 'app/providers/ThemeProvider/ui/ThemeProvider';
import QueryClientProvider from 'app/providers/api/QueryClientProvider';
import { AuthProvider } from 'app/providers/auth/AuthProvider';
const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <QueryClientProvider>
    <AuthProvider>
      <Router future={{ v7_startTransition: true, v7_relativeSplatPath: true }}>
        <MUThemeProvider>
          <ErrorBoundary>
            <App />
          </ErrorBoundary>
        </MUThemeProvider>
      </Router>
    </AuthProvider>
  </QueryClientProvider>,
);
